import PropTypes from 'prop-types';
import React from 'react';

import PlayerStat from './PlayerStat';

export default function PlayerStats({playerStats, platform, playlist}) {
  if (!playerStats) {
    return <div className="player-stats" />;
  }
  const stats = [];
  for (let i = 0; i < playerStats.length; i++) {
    const stat = playerStats[i];
    stats.push(<PlayerStat key={stat.name} stat={stat} platform={platform} playlist={playlist} />);
  }
  return <div className="player-stats">{stats}</div>;
}

PlayerStats.propTypes = {
  playerStats: PropTypes.array,
  platform: PropTypes.string,
  playlist: PropTypes.string,
};
